class PredictiveSearch extends HTMLElement {

  connectedCallback() {
    this.initPredictiveSearch();
  }

  initPredictiveSearch() {

    this.input = this.querySelector('#Search-In-Header');
    this.results = this.querySelector('#predictive-search-results');

    if (!this.input || !this.results) {
      setTimeout(() => this.initPredictiveSearch(), 100);
      return;
    }

    if (this.input.dataset.predictiveInit === "true") return;

    this.input.dataset.predictiveInit = "true";

    this.timeout = null;

    this.input.addEventListener(
      'input',
      this.onInput.bind(this)
    );

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) {
        this.closeResults();
      }
    });

  }


  onInput() {

    clearTimeout(this.timeout);

    const query = this.input.value.trim();

    if (!query) {
      this.closeResults();
      return;
    }


    this.timeout = setTimeout(() => {

      fetch(
        `/search/suggest?q=${encodeURIComponent(query)}&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[type]=query,product,collection,page,article&section_id=search-predictive-grid`
      )
      .then(response => response.text())
      .then(html => {

        const wrapper = document.createElement('div');
        wrapper.innerHTML = html;


        const section = wrapper.querySelector(
          '#shopify-section-search-predictive-grid'
        );


        if (section) {

          this.results.innerHTML = section.innerHTML;
          this.results.style.display = 'block';

        } else {

          this.results.innerHTML = '<div class="predictive-empty">No results found</div>';
          this.results.style.display = 'block';

        }

      })
      .catch(error => {
        console.error('Predictive Search Error:', error);
      });


    }, 300);

  }


  closeResults() {

    if (!this.results) return;

    this.results.innerHTML = '';
    this.results.style.display = 'none';

  }

}


customElements.define('predictive-search', PredictiveSearch);